import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

function ForgotPage() {
  // 'password' or 'username'
  const [tab, setTab] = useState('password');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Handles both password reset & username reminder
  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    setLoading(true);

    try {
      if (tab === 'password') {
        // Password reset request
        const res = await api.post('/auth/forgot-password', { email });
        setMessage(res.data.message || 'Check your email for the reset link.');
      } else {
        // Username reminder request
        const res = await api.post('/auth/forgot-username', { email });
        setMessage(res.data.message || 'If your email is registered, you will receive your username(s) soon.');
      }
    } catch (err) {
      const msg = err.response?.data?.message || 'Unable to process request.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="tab-toggle">
          <button
            className={tab === 'password' ? 'active' : ''}
            onClick={() => { setTab('password'); setMessage(''); setError(''); }}
          >
            Forgot Password
          </button>
          <button
            className={tab === 'username' ? 'active' : ''}
            onClick={() => { setTab('username'); setMessage(''); setError(''); }}
          >
            Forgot Username
          </button>
        </div>

        <h3 style={{ marginBottom: 0 }}>
          {tab === 'password' ? 'Forgot Password' : 'Forgot Username'}
        </h3>
        <p style={{ marginTop: 4 }}>
          {tab === 'password'
            ? 'Enter your email and we’ll send you a reset link if your account exists.'
            : 'Enter your email and we’ll remind you of your username(s) if your account exists.'}
        </p>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              autoComplete="username"
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          {message && <p className="success-message" style={{ color: 'green' }}>{message}</p>}
          {error && <p className="error-message">{error}</p>}
          <button type="submit" className="action-button" disabled={loading}>
            {loading ? 'Sending...' : (tab === 'password' ? 'Send Reset Link' : 'Send Username Reminder')}
          </button>
        </form>

        <Link to="/login" className="link-to-login">
          Back to Login
        </Link>
      </div>
    </div>
  );
}

export default ForgotPage;
